/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type CaseManagementDtoContactTracing =
  (typeof CaseManagementDtoContactTracing)[keyof typeof CaseManagementDtoContactTracing];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CaseManagementDtoContactTracing = {
  YES: 'YES',
  NO: 'NO',
  // UNKNOWN: 'UNKNOWN',
  COMPLETED: 'COMPLETED'
} as const;

export const CaseManagementDtoContactTracingType = {
  ZENTRIFUGAL: 'ZENTRIFUGAL',
  ZENTRIPETAL: 'ZENTRIPETAL',
  UNKNOWN: 'UNKNOWN'
} as const;

export type CaseManagementDtoContactTracingType =
  (typeof CaseManagementDtoContactTracingType)[keyof typeof CaseManagementDtoContactTracingType];
